import React from 'react';

const Navbar = () => {
  return (
    <nav id="navbar" className="navbar">
      <ul className="nav-menu">
        <li>
          <a data-scroll="home" href={'/#home'}
            className={`dot`}>
            <span className="text">Home</span>
            <span className="icon"><i className="fal fa-home"></i></span>
          </a>
        </li>
        <li>
          <a data-scroll="professional" href={'/#professional'}
            className="dot">
            <span className="text">Professional</span>
            <span className="icon"><i className="fal fa-tools"></i></span>
          </a>
        </li>
        <li>
          <a data-scroll="portfolio" href={'/#portfolio'}
            className={`dot`}>
            <span className="text">Portfolio</span>
            <span className="icon"><i className="fal fa-layer-group"></i></span>
          </a>
        </li>
        <li>
          <a data-scroll="education" href={'/#education'} className="dot">
            <span className="text">Education</span>
            <span className="icon"><i className="fal fa-graduation-cap"></i></span>
          </a>
        </li >
        <li>
          <a data-scroll="contact" href={'/#contact'} className="dot">
            <span className="text">Contact</span>
            <span className="icon"><i className="fal fa-envelope"></i></span>
          </a>
        </li >
      </ul >
    </nav >
  );
}

export default Navbar;
